<div class="downloadkey-container download-key-dialog">
  @if (!disableClose) {
    <button
      mat-icon-button
      tabindex="-1"
      class="clear-button"
      color="accent"
      (click)="closeDialog()"
      >
      <mat-icon>clear</mat-icon>
    </button>
  }
  <mat-card-title matLine id="key-title">
    {{ 'PAGES.SFTP.DOWNLOAD_KEY_MODAL.TITLE' | translate }}
  </mat-card-title>
  <mat-card-subtitle class="line-important" matLine>
    {{ 'PAGES.SFTP.DOWNLOAD_KEY_MODAL.SUBTITLE' | translate }}
  </mat-card-subtitle>
  <mat-card-subtitle matLine id="instruction-title" [innerHTML]="'PAGES.SFTP.DOWNLOAD_KEY_MODAL.SUBHEADER' | translate">
    <!--You will need an SFTP client. We recommend using <a href="https://filezilla-project.org/" target="_blank">FileZilla</a>. It is free and available for Mac or PC.-->
  </mat-card-subtitle>

  <mat-card-content>
    <mat-card-title matLine id="instruction-title">
      {{ 'PAGES.SFTP.DOWNLOAD_KEY_MODAL.LIST.HEADER' | translate }}
    </mat-card-title>
    <ol id="instruction-list">
      <li>{{ 'PAGES.SFTP.DOWNLOAD_KEY_MODAL.LIST.STEP_1' | translate }}</li>
      <li>
        {{ 'PAGES.SFTP.DOWNLOAD_KEY_MODAL.LIST.STEP_2' | translate }}
        <strong>{{ sftpDomain }}</strong>
      </li>
      <li>
        {{ 'PAGES.SFTP.DOWNLOAD_KEY_MODAL.LIST.STEP_3' | translate }}
        <strong>22</strong>
      </li>
      <li>{{ 'PAGES.SFTP.DOWNLOAD_KEY_MODAL.LIST.STEP_4' | translate }}</li>
      <li>{{ 'PAGES.SFTP.DOWNLOAD_KEY_MODAL.LIST.STEP_5' | translate }}</li>
      <li>
        {{ 'PAGES.SFTP.DOWNLOAD_KEY_MODAL.LIST.STEP_6' | translate }}
        <strong>{{ siteUid$ | async }}</strong>
      </li>
      <li>{{ 'PAGES.SFTP.DOWNLOAD_KEY_MODAL.LIST.STEP_7' | translate }}</li>
      <li>{{ 'PAGES.SFTP.DOWNLOAD_KEY_MODAL.LIST.STEP_8' | translate }}</li>
    </ol>
  </mat-card-content>
  <mat-card-actions layout-align="end right">
    <button
      mat-raised-button
      class="short-button alignright-button"
      (click)="downloadKey()"
      type="submit"
      color="accent"
      >
      {{ 'PAGES.SFTP.DOWNLOAD_KEY_MODAL.BUTTONS.DOWNLOAD_KEY' | translate }}
    </button>
    <button
      mat-button
      class="short-button alignright-button"
      (click)="copyKey()"
      id="copy-button"
      type="submit"
      color="accent"
      >
      {{ 'PAGES.SFTP.DOWNLOAD_KEY_MODAL.BUTTONS.COPY_KEY' | translate }}
    </button>
  </mat-card-actions>
</div>
